import { Column, Columns } from '@dixa/lib-shared-habla';
import { PropsWithChildren } from 'lib-shared-types-utils';

import { AnalyticsFilterLayoutEmpty } from './components/empty/analyticsFilterLayoutEmpty';
import { AnalyticsFilterLayoutLoading } from './components/loading/analyticsFilterLayoutLoading';
import { AnalyticsFilterLayoutRow } from './components/row/analyticsFilterLayoutRow';

export const AnalyticsFilterLayout = ({
  children,
}: PropsWithChildren): JSX.Element => (
  <Columns>
    <Column size="300px">{children}</Column>
  </Columns>
);

AnalyticsFilterLayout.Row = AnalyticsFilterLayoutRow;
AnalyticsFilterLayout.Empty = AnalyticsFilterLayoutEmpty;
AnalyticsFilterLayout.Loading = AnalyticsFilterLayoutLoading;
